import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CreateInstanceComponent } from './create-instance/create-instance.component';
import { RecaptchaV3Module } from 'ng-recaptcha';
import { InstanceCardComponent } from './instance-card/instance-card.component';
import { CreateServerComponent } from './create-server/create-server.component';
import { StripeCardComponent } from './stripe-card/stripe-card.component';
import { StripeSubscriptionComponent } from './stripe-subscription/stripe-subscription.component';
import { PopoverMenuComponent } from './popover-menu/popover-menu.component';
import { InstanceColumnsComponent } from './instance-columns/instance-columns.component';
import { InstanceBoxComponent } from './new/instance-box/instance-box.component';
import { ModalPlanUpgradedComponent } from './modal-plan-upgraded/modal-plan-upgraded.component';
import { ModalPhoneExtensionComponent } from './modal-phone-extension/modal-phone-extension.component';
import { ModalCountrySelectorComponent } from './modal-country-selector/modal-country-selector.component';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { BuyCreditsModalComponent } from './buy-credits-modal/buy-credits-modal.component';
import { AutoRechargeModalComponent } from './auto-recharge-modal/auto-recharge-modal.component';
import { CreditsInfoModalComponent } from './credits-info-modal/credits-info-modal.component';
import { OpenOtherProfileModalComponent } from './open-other-profile-modal/open-other-profile-modal.component';
import { CreditUsageChartComponent } from './credit-usage-chart/credit-usage-chart.component';
import { UseCaseChoiceComponent } from './use-case-choice/use-case-choice.component';
import { HelpWidgetComponent } from './help-widget/help-widget.component';
import { NgChartsModule } from 'ng2-charts';
import { LinkifyPipe } from '../pipes/linkify.pipe';



@NgModule({
  declarations: [
    CreateInstanceComponent,
    InstanceCardComponent,
    CreateServerComponent,
    StripeCardComponent,
    StripeSubscriptionComponent,
    PopoverMenuComponent,
    InstanceColumnsComponent,
    InstanceBoxComponent,
    ModalPlanUpgradedComponent,
    ModalPhoneExtensionComponent,
    ModalCountrySelectorComponent,
    HeaderComponent,
    SidebarComponent,
    ConfirmationModalComponent,
    BuyCreditsModalComponent,
    AutoRechargeModalComponent,
    CreditsInfoModalComponent,
    OpenOtherProfileModalComponent,
    CreditUsageChartComponent,
    UseCaseChoiceComponent,
    HelpWidgetComponent,
    // Declared here rather than in AppModule so the CEO module, which imports this
    // one, can render customer-written text with the same escaping.
    LinkifyPipe
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaV3Module,
    TranslateModule,
    RouterModule,
    NgChartsModule
  ],
  exports: [
    CreateInstanceComponent,
    InstanceCardComponent,
    CreateServerComponent,
    StripeCardComponent,
    StripeSubscriptionComponent,
    PopoverMenuComponent,
    InstanceColumnsComponent,
    InstanceBoxComponent,
    ModalPlanUpgradedComponent,
    ModalPhoneExtensionComponent,
    ModalCountrySelectorComponent,
    HeaderComponent,
    SidebarComponent,
    ConfirmationModalComponent,
    BuyCreditsModalComponent,
    AutoRechargeModalComponent,
    CreditsInfoModalComponent,
    OpenOtherProfileModalComponent,
    CreditUsageChartComponent,
    UseCaseChoiceComponent,
    HelpWidgetComponent,
    LinkifyPipe
  ]
})
export class ComponentsModule { }
